// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"d0086259","4727":"e4b93a9b","8999":"f411dff2","9507":"d0086259","9913":"f616d1ad"}[chunkId] + ".chunk.css";
};